module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/BB-026fc9f6f9a5757c5c617c033e87fba3.png";